import { Component, OnInit,Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../../comm/class/auth';

@Component({
  selector: 'app-check-permissions',
  templateUrl: './check-permissions.component.html',
  styleUrls: ['./check-permissions.component.css']
})
export class CheckPermissionsComponent implements OnInit {
    @Input() data: any; // 如果需要使用 post，可以通过 @Input() 传递
    @Input() type: number = 0;
    show: any = true;


    constructor(public httpClient: HttpClient,) { }

    ngOnInit(): void {
        this.chackpermission();
    }


    chackpermission(){

        // 抓「完整權限清單」(act:1)，與 ctrl-sidebar 一致。
        // 原本送 {data:this.data} 會走後端 checkPerssion 分支、allPerssion 回空陣列，
        // 前端又把空陣列寫回 localStorage 蓋掉正確清單 → 造成每次導航每個 gate 重打 checkperssion。
        const body = {act:1};

        let Storagedata:any = localStorage.getItem('usertoken_plus2'+Dep.user.id);
        if(typeof(Storagedata) == 'undefined'){
            Storagedata = "[]";

        }

        let permissionData:any = JSON.parse(Storagedata);
        if(Storagedata == null || permissionData.length == 0){
            this.httpClient.post<any>("/customer_service/checkperssion.php",body).subscribe(res => {

                const delayInMilliseconds = 600000; // 10 分鐘

                const incoming = res.data['allPerssion'];
                let incomingArr:any = [];
                try { incomingArr = JSON.parse(incoming) || []; } catch(e){ incomingArr = []; }

                let existing = localStorage.getItem('usertoken_plus2'+Dep.user.id);
                let existingArr:any = [];
                try { existingArr = existing ? (JSON.parse(existing) || []) : []; } catch(e){ existingArr = []; }

                // 只在「抓到非空清單」或「本來就沒快取」時才寫入，
                // 避免用空陣列蓋掉已存在的正確權限清單。
                if(incomingArr.length > 0 || existingArr.length === 0){
                    localStorage.setItem('usertoken_plus2'+Dep.user.id, incoming);
                    permissionData = incomingArr;
                    setTimeout(() => {
                        localStorage.removeItem('usertoken_plus2'+Dep.user.id);
                    }, delayInMilliseconds);
                }

            }, error => {
                console.log(error);
            });
        }

        let control = false;
        if (permissionData.indexOf(this.data) == -1) {
            control = true;
        }

        if(this.type == 1){
            this.show = !control;
        }else{
            this.show = control;
        }

    }
}
